import { MetadataField } from './MetadataField'
import { GroupingConfigReadOnly } from './GroupingConfigReadOnly'
import { CriteriaBuilder } from './CriteriaBuilder'
import { formatDateTime } from '@/utils/formatters'
import type { StoreModelDetailRead } from '@/types'

interface StoreModelDetailTabProps {
  model: StoreModelDetailRead
}

export function StoreModelDetailTab({ model }: StoreModelDetailTabProps) {
  return (
    <div className="flex flex-col gap-6">
      {/* Metadata grid */}
      <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
        <MetadataField label="ID" value={model.id} monospace />
        <MetadataField
          label="Allocation Basis"
          value={model.allocation_basis}
        />
        <MetadataField label="Store Count" value={model.store_count} />
        <MetadataField label="Group Count" value={model.group_count} />
        <MetadataField
          label="Total Allocation %"
          value={model.total_allocation_percent.toFixed(2)}
        />
        <MetadataField label="Grouping Method" value={model.grouping_method} />
        <MetadataField label="Description" value={model.description} />
        <MetadataField
          label="Recalculation Schedule"
          value={model.recalculation_schedule}
          monospace
        />
        <MetadataField
          label="Last Recalculated"
          value={formatDateTime(model.last_recalculated_at)}
        />
        <MetadataField
          label="Next Recalculation"
          value={formatDateTime(model.next_recalculation_at)}
        />
        <MetadataField
          label="Created"
          value={formatDateTime(model.created_at)}
        />
        <MetadataField
          label="Updated"
          value={formatDateTime(model.updated_at)}
        />
      </dl>

      {/* Criteria – read-only structured view */}
      {model.criteria && (
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-semibold text-foreground">Criteria</h3>
          <CriteriaBuilder
            criteria={model.criteria}
            onChange={() => {}}
            readOnly
          />
        </div>
      )}
      {model.grouping_method && model.grouping_config && (
        <GroupingConfigReadOnly
          method={model.grouping_method}
          config={model.grouping_config}
        />
      )}
    </div>
  )
}
